import * as React from "react";
import { Pill } from "@lululemon/ui-library";
import {
  trackEvent,
  EVENT_CATEGORY,
  EVENT_TYPE
} from "@lululemon/mwa-analytics";

const trackBraQuizPDP = (
  eventSubType,
  { id, type, text, attributes, ...rest }
) =>
  trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
    eventSubType,
    component: {
      id,
      type: type || "",
      text: text || "",
      position: -1,
      totalCount: -1,
      attributes: attributes || {},
      ...rest
    }
  });

export const trackBqPDPInteraction = (componentData) =>
  trackBraQuizPDP(EVENT_TYPE.INTERACTION, componentData);

export const translatePills = (translations) => (text) => {
  if (translations && Object.entries(translations).length) {
    const dict = new Map(Object.entries(translations));
    if (/\w+\s\d+$/.test(text)) {
      const [size, number] = text.split(" ");

      return dict.has(size.toLowerCase())
        ? `${dict.get(size.toLowerCase())} ${number}`
        : text;
    }

    return dict.get(text.toLowerCase().trim().replace(" ", "_")) || text;
  }

  return text;
};

export const toBraQuizSizePills = (braQuizSizesObj, getTextPill) => {
  const validKeys = ["letterSizeLabel", "numberedSizeLabel", "bandSize"];
  const isValidSize = ([key, size]) =>
    validKeys.includes(key) && !!size?.length;

  return (
    Object.entries(braQuizSizesObj)
      .filter(isValidSize)
      .map(([key, size]) => <Pill key={key}>{getTextPill(size)}</Pill>) || []
  );
};
